var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2245 20.902L16.8153 15.4929C18.1561 13.8582 18.9643 11.7643 18.9643 9.48214C18.9643 4.24745 14.7168 0 9.48214 0C4.24286 0 0 4.24745 0 9.48214C0 14.7168 4.24286 18.9643 9.48214 18.9643C11.7643 18.9643 13.8536 18.1607 15.4883 16.8199L20.8974 22.2245C21.2648 22.5918 21.8571 22.5918 22.2245 22.2245C22.5918 21.8617 22.5918 21.2648 22.2245 20.902ZM9.48214 17.077C5.2898 17.077 1.88265 13.6699 1.88265 9.48214C1.88265 5.29439 5.2898 1.88265 9.48214 1.88265C13.6699 1.88265 17.0816 5.29439 17.0816 9.48214C17.0816 13.6699 13.6699 17.077 9.48214 17.077Z",
    fill: "#343C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ed8f519a10e5ff5f72c06022dad0d65b.svg";
export { ForwardRef as ReactComponent };